import { readCookie, writeCookie } from '@ui/lib/cookies'

export const CLIENT_ID_COOKIE = 'atm_cid'
export const SESSION_ID_COOKIE = 'atm_sid'

export function getClientId(): string | undefined {
  let id = readCookie(CLIENT_ID_COOKIE)
  if (!id && typeof crypto !== 'undefined') {
    id = crypto.randomUUID()
    writeCookie(CLIENT_ID_COOKIE, id)
  }
  return id
}

export function getSessionId(): string | undefined {
  let id = readCookie(SESSION_ID_COOKIE)
  if (!id && typeof crypto !== 'undefined') {
    id = crypto.randomUUID()
    writeCookie(SESSION_ID_COOKIE, id)
  }
  return id
}
